import React from 'react'

import {
  Icon,
  Upload2,
  ProjectSearch,
  TrendingUp,
  Bulb,
  CubeOutlineSearch,
  PrinterSearch,
  Trophy,
  UsersOutline,
  SchoolOutline,
  TargetChallenge,
  Forum,
  BookOpen,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

const ICON_SIZE = { width: '20', height: '20' }

// Some nav labels ship with a decorative trailing emoji from i18n ("Sell More 🚀",
// "Designer Awards 🏆"); the redesigned dropdown renders clean labels.
const stripTrailingEmoji = (text) => text.replace(/\s*\p{Extended_Pictographic}+$/u, '')

// String icon keys -> Triangle UI glyphs.
const ICON_MAP = {
  upload: Upload2,
  project_search: ProjectSearch,
  trending_up: TrendingUp,
  bulb: Bulb,
  cube_search: CubeOutlineSearch,
  printer_search: PrinterSearch,
  trophy: Trophy,
  users: UsersOutline,
  tutorials: SchoolOutline,
  challenges: TargetChallenge,
  forum: Forum,
  blog: BookOpen,
}

function DropdownItem({ title = '', href = '', icon = '', image = '', trackText = '' }) {
  const IconComponent = icon ? ICON_MAP[icon] : null

  return (
    <li className="unified-nav__dropdown-item">
      <a
        className="unified-nav__dropdown-link cgt-body-base-semibold"
        href={href}
        data-track-label="For Designers"
        data-track-text={trackText}
      >
        <span className="unified-nav__dropdown-item-icon">
          {image ? (
            <img
              className="unified-nav__dropdown-item-image"
              src={image}
              alt=""
              loading="lazy"
              height="20"
              width="20"
            />
          ) : (
            IconComponent && (
              <Icon notSpaced color="dark" size={ICON_SIZE} svgComponent={IconComponent} />
            )
          )}
        </span>
        <span className="unified-nav__dropdown-item-label">{stripTrailingEmoji(title)}</span>
      </a>
    </li>
  )
}

DropdownItem.propTypes = {
  title: string,
  href: string,
  icon: string,
  image: string,
  trackText: string,
}

export default DropdownItem
